import React, { Component } from "react"
import { verifyClient } from "../../BackendServices/registrationAPI"
import { withTranslation } from "react-i18next"
import BusinessRegistration from "./BusinessRegistration"
import ConsumerRegistration from "./ConsumerRegistration"
import ErrorAlert from "../common/ErrorAlert"
import getParameter from "../common/getParam"

const win = window;

class Registration extends Component {
    state = {
        clientId: '',
        loading: false,
        genericError: null,
        isConsumer: null
    }

    getParameter(param) {
        const search = window.location.search;
        const params = new URLSearchParams(search);

        return params.get(param);
    }

    async componentDidMount() {
        let clientId = this.getParameter("client_id");
        let accountType = getParameter("account_type");

        if (accountType === null) {
            accountType = "personal"
        }

        let redirectURL = this.getParameter("redirect_url");
        if (redirectURL === null) {
            redirectURL = '/wps/portal/web/login-page?account_type=' + accountType;
        }

        if (clientId === null || clientId === '' || clientId === 'EPORTAL') {
            clientId = window.OAUTHUserName;
        }

        await this.verifyClientToken(clientId, redirectURL, accountType);
    }

    verifyClientToken = async (clientId, redirectURL, accountType) => {
        let requestBody = {
            "clientId": clientId
        }
        await this.setState({
            loading: true
        })

        try {
            let result = await verifyClient(requestBody);
            let isConsumer = true;

            if (clientId === window.OAUTHUserName) {
                if (accountType === 'personal') {
                    isConsumer = true
                } else if (accountType === 'business') {
                    isConsumer = false
                }
            } else {
                if (result.uiClientForms && result.uiClientForms["consumer"] === 'Y') {
                    isConsumer = true
                } else if (result.uiClientForms && result.uiClientForms["corporate"] === 'Y') {
                    isConsumer = false
                }
            }
            this.setState({
                clientInfo: result.uiClientForms,
                clientId: clientId,
                redirectURL: redirectURL,
                loading: false,
                isConsumer: isConsumer
            })

        } catch (error) {
            this.setState({
                genericError: error.message,
                loading: false
            })
        }
    }

    render() {
        return (
            <>
                {this.state.loading && <div className="loading">Loading&#8230;</div>}

                <div className="loginPage">
                    {this.state.genericError && (
                        <>
                            <ErrorAlert error={this.state.genericError} />
                            <div style={{ display: "none" }} className={this.state.genericError ? "api-error" : ""}>{this.state.genericError}</div>
                        </>
                    )}

                    {!this.state.genericError && this.state.isConsumer !== null && <section className="login_form">
                        {this.state.isConsumer
                            && <ConsumerRegistration redirectURL={this.state.redirectURL} clientInfo={this.state.clientInfo} isThirdParty={(this.state.clientId === '' || this.state.clientId === window.OAUTHUserName) ? false : true} clientId={this.state.clientId} />
                        }
                        {!this.state.isConsumer
                            && <BusinessRegistration redirectURL={this.state.redirectURL} clientInfo={this.state.clientInfo} isThirdParty={(this.state.clientId === '' || this.state.clientId === window.OAUTHUserName) ? false : true} clientId={this.state.clientId} />
                        }
                    </section>}
                </div>
            </>
        )
    }
}
export default withTranslation()(Registration);
